import { Form } from '@hatchery/form-framework';
document.addEventListener('DOMContentLoaded', () => {
    const formEl = document.getElementById('signup-form-element');
    if (!formEl)
        return;
    // @ts-expect-error - TS doesn't know about the Form class
    new Form(formEl, { pageId: 'contact-form' });
});
